module.exports = __webpack_public_path__ + "img/doctor2.c03e915a.png";